/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const actualsVsPlanStatsSchema = z.object({
  itemCount: z.int(),
  percentageDiff: z.number().nullish(),
  totalActualSeconds: z.int(),
  totalPlanSeconds: z.int(),
});
